import globalTheme from '../global'

const Drawer = {
	BHMiniCart: {
		defaultProps: {
			anchor: 'right',
		},
	},
	BHMiniWishList: {
		defaultProps: {
			anchor: 'right',
		},
	},
	MuiDrawer: {
		styleOverrides: {
			paper: {
				color: globalTheme.palette.primary.main,
			},
		},
	},
}

export default Drawer
